import React, { Fragment, Suspense, useCallback, useEffect, useState } from "react"
import { Outlet, useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { parse } from "query-string"
import { haveAuth, logout } from "utils"
import clsx from "clsx"

import {
  fetchContractDeactivationStatus,
  fetchNotViewedOrders,
  fetchSystemSettings,
  fetchUserAccountInfo,
  fetchWalletDetails
} from "@redux"
import { PageLoader } from "components"
import SideNavigation from "./Sidenavigation"
import TopNavigation from "./TopNavigation"
import TopupResultModal from "./TopupResultModal"
import SmsPaymentResultModal from "./SmsPaymentResultModal"
import SystemDeactivationWarningModal from "./SystemDeactivationWarningModal"
import classes from "./index.module.scss"

const PrivateContainer = () => {
  const navigate = useNavigate()

  const accountId =
    useSelector(state => state.userAccountInfo._id)

  const systemSettings =
    useSelector(state => state.systemSettings)

  const { isTopup, isSmsPayment } = parse(window.location.search)

  const [openSidebar, setOpenSidebar] = useState(window.innerWidth >= 1140)

  const dispatch = useDispatch()

  const getNumberOfNotViewedOrders = () => {
    const haveAccess =
      haveAuth(["viewLatestOrders"]) ||
      haveAuth(["viewOtherAccessesOrders"])

    if (!haveAccess) return

    const query = {}

    if (!haveAuth(["viewOtherAccessesOrders"])) {
      query.addedByAccountId = accountId
    }

    dispatch(
      fetchNotViewedOrders(query)
    )
  }

  const initialization = async () => {
    dispatch(fetchUserAccountInfo())

    dispatch(fetchSystemSettings())

    dispatch(fetchWalletDetails())

    dispatch(fetchContractDeactivationStatus())

    getNumberOfNotViewedOrders()
  }

  const autoLogout =
    useCallback(() => {
      if (localStorage.getItem("at")) return

      logout()

      navigate("/")
    }, [])

  useEffect(() => {
    initialization()

    window.addEventListener("focus", autoLogout)

    return () => {
      window.removeEventListener("focus", autoLogout)
    }
  }, [])

  const loading =
    !systemSettings.websiteFeatures || !accountId

  if (loading) return <PageLoader />

  return (
    <Fragment>
      <SideNavigation
        openSidebar={openSidebar}
        setOpenSidebar={setOpenSidebar}
      />

      <main
        className={clsx(
          classes["container"],
          openSidebar && classes["move-right"]
        )}
      >
        <TopNavigation
          openSidebar={openSidebar}
          setOpenSidebar={setOpenSidebar}
        />

        <div className={classes["wrapper"]}>
          <Suspense fallback={<PageLoader />}>
            <Outlet />
          </Suspense>
        </div>
      </main>

      <SystemDeactivationWarningModal />

      {isTopup && <TopupResultModal />}

      {isSmsPayment && <SmsPaymentResultModal />}
    </Fragment>
  )
}

export default PrivateContainer